import { cn } from '@shape-construction/arch-ui/src/utils/classes';
import { ShapeLoader } from './ShapeLoader';

export type LoadingSpinnerProps = {
  variant?: 'screen';
};

// The ambient treatment (opaque ground, aurora backdrop, cycling messages) is
// screen-only; the many inline call sites render just the small animated mark
// on a transparent background.
export const LoadingSpinner = ({ variant }: LoadingSpinnerProps) => {
  return (
    <div
      className={cn('h-full w-full flex items-center justify-center', {
        'fixed inset-0 overflow-hidden bg-neutral-subtlest': variant === 'screen',
      })}
      data-testid="loading-spinner"
    >
      {variant === 'screen' && <div className="shape-loader-backdrop" aria-hidden="true" />}
      <ShapeLoader variant={variant} />
    </div>
  );
};
